import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();

  const handleCreateProject = () => {
    navigate('/prompt-input');
  };

  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 md:py-20 lg:py-24 px-4">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-full bg-muted flex items-center justify-center mb-4 md:mb-6">
          <Icon name="SearchX" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-2">
          No Projects Found
        </h3>
        <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
          No projects match your current filters. Try adjusting your search criteria or clear all filters.
        </p>
        <Button
          variant="outline"
          size="default"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 md:py-20 lg:py-24 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center mb-6 md:mb-8 animate-pulse-subtle">
        <Icon name="Sparkles" size={48} color="#FFFFFF" />
      </div>
      <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-3">
        Start Building Something Amazing
      </h3>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground text-center max-w-lg mb-8">
        You haven't generated any projects yet. Describe your application idea and let AI create a complete, production-ready codebase for you.
      </p>
      <Button
        variant="default"
        size="lg"
        iconName="Plus"
        iconPosition="left"
        onClick={handleCreateProject}
      >
        Generate Your First Project
      </Button>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl w-full">
        <div className="text-center">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex items-center justify-center mx-auto mb-3">
            <Icon name="Zap" size={24} className="text-primary" />
          </div>
          <h4 className="text-sm md:text-base font-semibold mb-2">Lightning Fast</h4>
          <p className="text-xs md:text-sm text-muted-foreground">
            Generate complete projects in minutes, not days
          </p>
        </div>
        <div className="text-center">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-accent/10 flex items-center justify-center mx-auto mb-3">
            <Icon name="Code2" size={24} className="text-accent" />
          </div>
          <h4 className="text-sm md:text-base font-semibold mb-2">Production Ready</h4>
          <p className="text-xs md:text-sm text-muted-foreground">
            Clean, maintainable code following best practices
          </p>
        </div>
        <div className="text-center">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-success/10 flex items-center justify-center mx-auto mb-3">
            <Icon name="Download" size={24} className="text-success" />
          </div>
          <h4 className="text-sm md:text-base font-semibold mb-2">Instant Download</h4>
          <p className="text-xs md:text-sm text-muted-foreground">
            Get your complete project as a ZIP file instantly
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;